import * as Yup from 'yup';
import { createMediaSchema, createProductDefault } from '../../../utils/sharedSchema.utils';

const productsBlockSchema = Yup.object().shape({
  moreProducts: Yup.array()
    .of(
      Yup.object().shape({
        id: Yup.string(),
        title: Yup.string().label('Title').required().default(''),
        description: Yup.string().label('Description').required().default(''),
        image: createMediaSchema('Product image missing'),
        link: Yup.string().label('Link').url(),
      })
    )
    .required('Please add at least one product')
    .min(1)
    .default([createProductDefault()]),
});

export default productsBlockSchema;
